import { useContext } from "react";

import { AnyEntity } from "@mapmycustomers/shared/types/entity";

import IViewContext from "@app/component/view/types/IViewContext";
import ViewContext from "@app/component/view/utils/ViewContext";

const useView = <T = AnyEntity>(): IViewContext<T> => {
  return useContext(ViewContext) as unknown as IViewContext<T>;
};

export default useView;
